import {register} from '../vendor/theme-scripts/theme-sections';
import {swatchGridSection} from '../features/swatch';

register('collection-row', swatchGridSection);
